import React from 'react'

import Stack from '@mui/material/Stack'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import FormGroup from '@mui/material/FormGroup'

interface CheckboxGroupProps {
  isReadonly?: boolean
  values: Array<{ id: number; label: string }>
  header: string
  checkedValues: Array<number>
  onChangeValue: (value: number, isChecked: boolean) => void
}

const CheckboxGroup = (props: CheckboxGroupProps): JSX.Element => {
  return (
    <Stack direction="row" flexWrap="wrap" sx={{ mr: 3, mb: 2 }}>
      <FormControl component="fieldset" variant="standard">
        <FormLabel component="legend">{props.header}</FormLabel>
        <FormGroup sx={{ alignItems: 'flex-start' }}>
          {props.values.map((x) => {
            return (
              <FormControlLabel
                key={x.id}
                disabled={props.isReadonly}
                control={
                  <Checkbox
                    checked={props.checkedValues.indexOf(x.id) > -1}
                    onChange={(_event, isChecked) => props.onChangeValue(x.id, isChecked)}
                  />
                }
                label={x.label}
              />
            )
          })}
        </FormGroup>
      </FormControl>
    </Stack>
  )
}

export default CheckboxGroup
